import { SxProps, Theme } from '@mui/material';

export interface BrandingItem {
  column: 0 | 1;
  opacity: number;
  rotate: number;
  side: 'left' | 'right';
  size: number;
  top: string;
}

export const BRANDING_ITEMS: readonly BrandingItem[] = [
  { column: 0, opacity: 0.12, rotate: -18, side: 'left', size: 56, top: '10%' },
  { column: 1, opacity: 0.08, rotate: 14, side: 'left', size: 42, top: '16%' },
  { column: 0, opacity: 0.1, rotate: -12, side: 'left', size: 44, top: '24%' },
  { column: 1, opacity: 0.15, rotate: -26, side: 'left', size: 64, top: '34%' },
  { column: 0, opacity: 0.16, rotate: 10, side: 'left', size: 66, top: '42%' },
  { column: 1, opacity: 0.09, rotate: 18, side: 'left', size: 46, top: '52%' },
  { column: 0, opacity: 0.13, rotate: 24, side: 'left', size: 52, top: '62%' },
  { column: 1, opacity: 0.14, rotate: -10, side: 'left', size: 58, top: '72%' },
  { column: 0, opacity: 0.1, rotate: 14, side: 'left', size: 40, top: '80%' },
  { column: 1, opacity: 0.08, rotate: -22, side: 'left', size: 44, top: '88%' },
  { column: 0, opacity: 0.18, rotate: 16, side: 'right', size: 74, top: '12%' },
  { column: 1, opacity: 0.09, rotate: -18, side: 'right', size: 46, top: '20%' },
  { column: 0, opacity: 0.14, rotate: 22, side: 'right', size: 58, top: '28%' },
  { column: 1, opacity: 0.13, rotate: 12, side: 'right', size: 52, top: '38%' },
  { column: 0, opacity: 0.11, rotate: -20, side: 'right', size: 48, top: '46%' },
  { column: 1, opacity: 0.16, rotate: -12, side: 'right', size: 68, top: '56%' },
  { column: 0, opacity: 0.17, rotate: -14, side: 'right', size: 72, top: '64%' },
  { column: 1, opacity: 0.1, rotate: 20, side: 'right', size: 44, top: '74%' },
  { column: 0, opacity: 0.12, rotate: -24, side: 'right', size: 54, top: '84%' },
  { column: 1, opacity: 0.08, rotate: 26, side: 'right', size: 40, top: '90%' },
] as const;

export const BackgroundBrandingRootStyles: SxProps<Theme> = {
  '@media (max-width: 1680px)': {
    display: 'none',
  },
  '--branding-shift': 'clamp(0px, calc((1920px - 100vw) * 0.375), 75px)',
  inset: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 0,
};

export const getBackgroundBrandingSideStyles = (side: 'left' | 'right'): SxProps<Theme> => ({
  bottom: 0,
  [side]: 0,
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  width: 'calc((100% - 1600px) / 2)',
});

const BRANDING_COLUMN_DEFAULT_OFFSET = {
  0: 100,
  1: 50,
} as const;

export const getBrandingItemStyles = (item: BrandingItem): SxProps<Theme> => {
  const defaultOffset = BRANDING_COLUMN_DEFAULT_OFFSET[item.column];
  const positionProperty = item.side === 'left' ? 'right' : 'left';

  return {
    backgroundImage: 'url("/orange_logo.png")',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    height: `${item.size}px`,
    [positionProperty]: `calc(${defaultOffset}px - var(--branding-shift))`,
    opacity: item.opacity,
    position: 'absolute',
    top: item.top,
    transform: `translateY(-50%) rotate(${item.rotate}deg)`,
    width: `${item.size}px`,
  };
};
